<template>
  <div class="configuration-tab">
    <DxTextBox
      v-model="introTextDutch"
      label="Intro text dutch"
      class="custom-input"
      :disabled="!isSuperAdmin"
    >
      <DxValidator :validation-rules="[requiredFieldRule]" />
    </DxTextBox>
    <DxTextBox
      v-model="introTextGerman"
      label="Intro text german"
      class="custom-input"
      :disabled="!isSuperAdmin"
    >
      <DxValidator :validation-rules="[requiredFieldRule]" />
    </DxTextBox>

    <DxTextBox
      v-model="helpTextDutch"
      label="Help text dutch"
      class="custom-input"
      :disabled="!isSuperAdmin"
    >
      <DxValidator :validation-rules="[requiredFieldRule]" />
    </DxTextBox>

    <DxTextBox
      v-model="helpTextGerman"
      label="Help text german"
      class="custom-input"
      :disabled="!isSuperAdmin"
    >
      <DxValidator :validation-rules="[requiredFieldRule]"
    /></DxTextBox>
    <DxNumberBox
      v-model="globalRateLimiting"
      :min="0"
      label="Global rate limiting"
      label-mode="floating"
      class="custom-input"
      :disabled="!isSuperAdmin"
    >
      <DxValidator
        :validation-rules="[
          requiredFieldRule,
          greaterThanZeroRule,
          integerOnlyRule
        ]"
      />
    </DxNumberBox>
    <DxButton
      text="Save"
      @click="updateSettings"
      class="orange-btn custom-btn"
      :disabled="!isSuperAdmin"
    />
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import store from "../../store/index";

import aiService from "../../services/ai.service";

import DxTextBox from "devextreme-vue/text-box";
import DxValidator from "devextreme-vue/validator";
import DxButton from "devextreme-vue/button";
import DxNumberBox from "devextreme-vue/number-box";

const requiredFieldRule = {
  type: "required",
  message: "Field is required"
};
const greaterThanZeroRule = {
  type: "custom",
  validationCallback: e => {
    const val = Number(e.value);
    return !isNaN(val) && val > 0;
  },
  message: "Value must be greater than 0"
};
const integerOnlyRule = {
  type: "custom",
  validationCallback: e => Number.isInteger(e.value),
  message: "Only whole numbers allowed"
};
onMounted(async () => {
  await aiService.getAISettings();
});

const isSuperAdmin = computed(() => {
  return store.state.auth.authUser.isSuperAdmin;
});

const introTextDutch = computed({
  get: () => store.state.aiSettings.settings.introTextDutch,
  set: val => store.commit("aiSettings/updateIntroTextDutch", val)
});
const introTextGerman = computed({
  get: () => store.state.aiSettings.settings.introTextGerman,
  set: val => store.commit("aiSettings/updateIntroTextGerman", val)
});
const helpTextDutch = computed({
  get: () => store.state.aiSettings.settings.helpTextDutch,
  set: val => store.commit("aiSettings/updateHelpTextDutch", val)
});
const helpTextGerman = computed({
  get: () => store.state.aiSettings.settings.helpTextGerman,
  set: val => store.commit("aiSettings/updateHelpTextGerman", val)
});

const settings = computed({
  get: () => store.state.aiSettings.settings
});
const globalRateLimiting = computed({
  get: () => store.state.aiSettings.settings.globalRateLimiting,
  set: val => store.commit("aiSettings/updateGlobalRateLimiting", val)
});

const updateSettings = async () => {
  await aiService.updateAISettings(settings.value);
};
</script>
<style lang="scss"></style>
